import { render } from "./hue.vue?vue&type=template&id=cc3ca1ac"
import script from "./hue.vue?vue&type=script&lang=js"
export * from "./hue.vue?vue&type=script&lang=js"

import "./hue.vue?vue&type=style&index=0&id=cc3ca1ac&lang=css"
script.render = render

export default script